// extracted by mini-css-extract-plugin
export default {"card":"logIn__card__RLkxN","logo":"logIn__logo__onlOG","title":"logIn__title__K7P2O"};